import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { AppendixCommandHandlerResolver } from '../../service/command/appendix-command-handler-resolver.service';
import { Appendix } from '../../model/appendix';
import { AppendixService } from '../../service/data/appendix.service';
import { appendixCommand } from '../../command/appendix.command';
import { PreviewAppendixCommandHandler } from '../../service/command/preview-appendix-command-handler.service';

@Component({
    selector: 'app-appendix-manager',
    templateUrl: './../../../core/component/multiselect-object-manager/multiselect-object-manager.template.html',
    styleUrls: ['./../../../core/component/multiselect-object-manager/multiselect-object-manager.component.scss'],
    providers: [AppendixCommandHandlerResolver, PreviewAppendixCommandHandler],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppendixManagerComponent extends MultiselectObjectManagerComponentBase<Appendix> {
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    dataService: AppendixService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: AppendixCommandHandlerResolver
  ) {
    super(dataService, dispatcher, handlerResolver, messageService, navigationService);
    this.columnDefinition = columnDefinitionService.create('Appendix');
    this.title = 'APPENDIX.LIST_HEADER';
    this.preferencesKey = 'rent.appendix.list';
    this.addContextMenuItemDefinition('APPENDIX.PREVIEW_COMMAND', appendixCommand.previewAppendix);
  }
}
